import { stringify } from 'qs';
import http from '@webapp-next/lib/request/webapp/http';

const url = '/api/v1/internal/management/employees';

export default async ({
  id,
  filters = [],
  sorts = [],
  limit,
  offset,
  exposeMeta,
} = {}) => {
  //
  if (id) {
    const response = await http.get(`${url}/${id}`).then(({ data }) => data);
    return exposeMeta ? response : response.data;
  }

  let query = { limit, offset, filters: [], sorts: [] };

  if (filters.locations && !(filters.locations instanceof Array)) {
    console.error('locations should be an array');
    return Promise.reject('locations should be an array');
  } else if (
    filters.locations instanceof Array &&
    filters.locations.length > 0
  ) {
    filters.locations.forEach(id => {
      query.filters.push({
        key: 'byMainLocationIds',
        operator: 'eq',
        value: id,
      });
    });
  }

  if (
    filters.byAdditionalLocationIds &&
    !(filters.byAdditionalLocationIds instanceof Array)
  ) {
    console.error('byAdditionalLocationIds should be an array');
    return Promise.reject('byAdditionalLocationIds should be an array');
  } else if (
    filters.byAdditionalLocationIds instanceof Array &&
    filters.byAdditionalLocationIds.length > 0
  ) {
    filters.byAdditionalLocationIds.forEach(id => {
      query.filters.push({
        key: 'byAdditionalLocationIds',
        operator: 'eq',
        value: id,
      });
    });
  }

  if (filters.jobPositions && !(filters.jobPositions instanceof Array)) {
    console.error('jobPositions should be an array');
    return Promise.reject('jobPositions should be an array');
  } else if (
    filters.jobPositions instanceof Array &&
    filters.jobPositions.length > 0
  ) {
    filters.jobPositions.forEach(id => {
      query.filters.push({
        key: 'byJobPositions',
        operator: 'eq',
        value: id,
      });
    });
  }

  if (filters.ages && !(filters.ages instanceof Array)) {
    console.error('ages should be an array');
    return Promise.reject('ages should be an array');
  } else if (filters.ages instanceof Array && filters.ages.length > 0) {
    filters.ages.forEach(id => {
      query.filters.push({
        key: 'byAges',
        operator: 'eq',
        value: id,
      });
    });
  }

  if (filters.trainings && !(filters.trainings instanceof Array)) {
    console.error('trainings should be an array');
    return Promise.reject('trainings should be an array');
  } else if (
    filters.trainings instanceof Array &&
    filters.trainings.length > 0
  ) {
    filters.trainings.forEach(id => {
      query.filters.push({
        key: 'byTrainingIds',
        operator: 'eq',
        value: id,
      });
    });
  }

  const response = await http
    .get(`${url}?${stringify(query)}`)
    .then(({ data }) => data);
  return exposeMeta ? response : response.data;
};
